import { actions } from "react-redux-form";
import {
    getVendorDetails,
    getChargeMappingUploadTypes,
    setChargeMappingUploadError,
    ChargeMappingModel
} from "../../../../constants/model-reducers/external/invoice/invoice-upload/charge-mapping.setting";
import { httpDownload, httpGet, httpPost } from "../../../../utils/api.utils";
import { convertToFormatLocalDate } from '../../../../utils/helpers.utils';



export const chargeMappingFormInitialState=ChargeMappingModel;

const defaultState = ()=>({
    vendorOptions:[],
    chargeMappingUploadTypeOptions: [],
    chargeMappingUploadError:false
});

const initialState=defaultState();

function GetVendorName(vendorId, vendorOptions) {
    const vendor = vendorOptions.find(option => option.Key === vendorId);
    const vendorName = vendor ? vendor.Value : '';
    return vendorName;
}

export const chargeMappingAction = {
    getVendorDetails:() => async(dispatch, state) => {
        var res = await httpPost(`external/invoiceupload/getChargeMappingUploadVendors`); 
        if(res.ok === false)
        {
            dispatch({
                type: setChargeMappingUploadError,
                chargeMappingUploadError: false,
                vendorOptions: []
            })
        } else {
            dispatch({
                type: getVendorDetails,
                data: res
            }); 
        }     
    },
    getChargeMappingUploadTypes:() => async(dispatch, state) => {
        var res = await httpPost(`external/invoiceupload/getChargeMappingUploadTypes`); 
        if(res.ok === false)
        {
            dispatch({
                type: setChargeMappingUploadError,
                chargeMappingUploadError: false,
                chargeMappingUploadTypeOptions: []
            })
        } else {
            dispatch({
                type: getChargeMappingUploadTypes,
                data: res
            }); 
        }     
    },
    extractChargeMapping: () => async(dispatch, state) => {

        const {chargeMappingForm} = state().form;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat } = state().adminSetting;

        const vendorState=state()
        const {vendorOptions}=vendorState.chargeMappingUpload;
        const VendorName = GetVendorName(chargeMappingForm.vendorId, vendorOptions);

        var filename = `${dealName} – Charge Mapping - ${VendorName} - ${convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-')}`;

        try {
            const response = await httpDownload(`external/invoiceupload/getExtractChargeMapping/${chargeMappingForm.vendorId}`)
                if (response.ok) {
                        response.blob().then(function (blob) {
                            let downloadUrl = window.URL.createObjectURL(blob);
                            //Hide Loading
                            let a = document.createElement('a');
                            if (window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveOrOpenBlob(blob, filename);
                            } else if (typeof a.download === 'undefined') {
                                window.location = downloadUrl;
                            } else {
                                a.href = downloadUrl;
                                a.download = filename + '.xlsx';
                                document.body.appendChild(a);
                                a.click();
                            }
                        });
                        dispatch(actions.change('chargeMappingForm.extractError',false));
                } else {
                    dispatch(actions.change('chargeMappingForm.extractError',true));
                }

            }catch (error) {
                dispatch(actions.change('chargeMappingForm.extractError',true));
            }
    },
    postExecuteProcess: (UploadId) => () => {
        var url = 'external/adminupload/executePackage';

        httpPost(url, UploadId);
    },
    resetChargeMappingUploadForm:()=>async(dispatch,state) =>{
        dispatch(actions.reset('chargeMappingForm.vendorId'));
        dispatch(actions.reset('chargeMappingForm.chargeMappingUploadTypeId'));
        dispatch(actions.reset('chargeMappingForm.extractError'));
    },
    downloadChargeMappingTemplate: (fileAttachmentModule, fileName) => async (dispatch, getState) => {
        const encodedFileName = encodeURIComponent(fileName);
        try {
            const response = await httpDownload(`common/fileAttachment/downloadFile/${fileAttachmentModule}/${encodedFileName}`);
            if (response.ok) {
                response.blob().then(function (blob) {
                    let downloadUrl = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else {
                        a.href = downloadUrl;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                });
            } else {
                dispatch({
                    type: setChargeMappingUploadError,
                    chargeMappingUploadError: false,
                })
            }
        } catch (error) {
            dispatch({
                type: setChargeMappingUploadError,
                chargeMappingUploadError: false,
            })
        }
    }
}

export const reducer=(state,action)=>{
    state = state || initialState;
    switch(action.type) {
        case getVendorDetails:
            return {
                ...state,
                vendorOptions: action.data
            }
        case getChargeMappingUploadTypes:
            return {
                ...state,
                chargeMappingUploadTypeOptions: action.data
            }
        case setChargeMappingUploadError:
            return {
                ...state,
                chargeMappingUploadError: action.chargeMappingUploadError
            } 
        default:
            return state
        }
}